// import external dependencies
import 'jquery';
// Import everything from autoload
import './autoload/ajax.js'; import './autoload/dropdown.js'; import './autoload/modal.js'
// le menu
import 'mmenu-js';

// le sticky header
// import 'mhead-js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import search from './routes/search';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  search,
});

// Load Events
jQuery(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js